export const fetchPaginatedResults = (
    url: string,
    container: HTMLElement,
    resultsContainerSelector: string,
    loadMoreButtonSelector: string,
): Promise<void> => {
    return fetch(url, {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
    })
        .then((res) => res.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const newResults = doc.querySelector<HTMLElement>(
                resultsContainerSelector,
            );
            if (!newResults) return;

            const currentButton = container.querySelector<HTMLButtonElement>(
                loadMoreButtonSelector,
            );
            currentButton?.remove();

            container.insertAdjacentHTML("beforeend", newResults.innerHTML);
        })
        .catch((err) => {
            console.error("Error fetching next section:", err);
        });
};
